module.exports = __webpack_public_path__ + "img/1.8d7ed894.png";